import React from 'react';
import { Button } from '@chakra-ui/react';
import { ChevronUpIcon } from '@chakra-ui/icons';
import {useTranslation} from "react-i18next";

const ScrollToTopButton: React.FC = () => {

    const { t } = useTranslation();

    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    };

    return (
        <Button
            onClick={scrollToTop}
            position="fixed"
            bottom="100px"
            right="20px"
            zIndex={999}
            colorScheme='green'
            borderRadius="full"
            boxShadow="md"
            mr={"5vw"}
            rightIcon={<ChevronUpIcon />}
        >
            {t('common.scroll_to_top')}
        </Button>
    );
};

export default ScrollToTopButton;